import { render, staticRenderFns } from "./jumpLogin.vue?vue&type=template&id=57bd634e&scoped=true"
import script from "./jumpLogin.vue?vue&type=script&lang=js"
export * from "./jumpLogin.vue?vue&type=script&lang=js"
import style0 from "./jumpLogin.vue?vue&type=style&index=0&id=57bd634e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd634e",
  null
  
)

export default component.exports